import { useMutation } from "@outschool/ui-apollo";
import { useCallback } from "react";
import {
  GetS3FileUploadUrlMutation,
  GetS3FileUploadUrlMutationVariables,
} from "@outschool/gql-frontend-generated";
import { getS3FileUploadUrlMutation } from "../graphql/queries/fileUploadS3Url";

export function useGetS3FileUploadUrlMutation() {
  const [mutate, { data, loading, error }] = useMutation<
    GetS3FileUploadUrlMutation,
    GetS3FileUploadUrlMutationVariables
  >(getS3FileUploadUrlMutation);

  const getS3FileUploadUrl = useCallback(
    async (fileName: string) => {
      const response = await mutate({ variables: { fileName } });
      return response.data?.getS3FileUploadUrl;
    },
    [mutate]
  );

  return { getS3FileUploadUrl, data, loading, error };
}
